module.exports = __webpack_public_path__ + "media/images/cookie_dough_cover-4bfa3a94475504bb2510313a83f379eb.jpg";